import { REGEX_DATETIME } from '../constants/dates';
export const isValidISODate = (date) => {
    const [year, month, day] = date.split(/[-/]+/).map(Number);
    const dateObj = new Date(year, month - 1, day);
    return (dateObj.getUTCFullYear() === year &&
        dateObj.getUTCMonth() + 1 === month &&
        dateObj.getUTCDate() === day);
};
export const isValidISOHour = (hour) => {
    const [hours, minutes, seconds] = hour.split(':').map(Number);
    const dateObj = new Date();
    dateObj.setHours(hours, minutes, seconds);
    return (dateObj.getHours() === hours &&
        dateObj.getMinutes() === minutes &&
        dateObj.getSeconds() === seconds);
};
export const isValidDateTimeString = (input, type) => new RegExp(REGEX_DATETIME[type]).test(input);
export const getDateISOString = (date) => {
    if (date)
        return date.toISOString().split('T')[0];
    return;
};
export const getDayMonthFullYear = (date) => {
    let newDate;
    if (/-/g.test(date)) {
        newDate = date.split('-').reverse();
    }
    else {
        newDate = date.split('/');
    }
    return newDate;
};
export const getDatetimeValues = (date) => {
    date = date.replace('T', ' ');
    const datetimeSplit = date.split(' ');
    const [day, month, fullYear] = getDayMonthFullYear(datetimeSplit[0]);
    const [hours, minutes, seconds] = datetimeSplit[1].split(':');
    return {
        day: Number(day),
        month: Number(month) - 1,
        fullYear: Number(fullYear),
        hours: Number(hours),
        minutes: Number(minutes),
        seconds: Number(seconds)
    };
};
export const getDatetimeArguments = (date) => {
    const { day, month, fullYear, hours, minutes, seconds } = getDatetimeValues(date);
    return [fullYear, month, day, hours, minutes, seconds];
};
